<template>
  <Component
    :is="currentTab.createComponent"
    v-if="currentTab.createComponent"
    @closed="openTab(currentTab.value)"
  />
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import useApiRoutes from '../useApiRoutes';
import useApiTabs from '../useApiTabs';

const route = useRoute();
const { getTabByValue } = useApiTabs();
const { openTab } = useApiRoutes();

const currentTab = computed(() => getTabByValue(route.params.tab as string));

useHead({
  title: computed(() => `Create - ${currentTab.value.name} - API - Crossbeam`),
});
</script>
